<div class="o-grid o-grid--wrap@up-to-md o-grid--center-h" [ngStyle]="vm.loading && {'min-height': '254px', 'position': 'relative'}">
	<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fit@md-and-up u-no-pr u-no-p@up-to-md" *ngIf="vm.initialized">
		<!-- User data: general -->
		<p class="c-text c-text--bold c-text--lg u-osb-sm">{{ vm.ticket.patient.firstname }} {{ vm.ticket.patient.lastname }}</p>
		<div class="o-grid u-osb-xs" *ngIf="vm.ticket.patient.personalCode">
			<div class="o-grid__cell o-grid__cell--slim u-no-pl">
				<p class="c-text c-text--gray">{{ 'Booking.Personal_Code' | translate }}</p>
			</div>
			<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pr">
				<p class="c-text c-text--right">{{ vm.ticket.patient.personalCode }}</p>
			</div>
		</div>
		<div class="o-grid u-osb-xs" *ngIf="vm.ticket.patient.phoneNumber">
			<div class="o-grid__cell o-grid__cell--slim u-no-pl">
				<p class="c-text c-text--gray">{{ 'Modal.Form.Label.Phone_Number' | translate }}</p>
			</div>
			<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pr">
				<p class="c-text c-text--right">{{ vm.ticket.patient.phoneNumber }}</p>
			</div>
		</div>
		<div class="o-grid u-osb-xs" [hidden]="vm.ticket.patient.email == 'reserved@minudoc.ee'">
			<div class="o-grid__cell o-grid__cell--slim u-no-pl">
				<p class="c-text c-text--gray">{{ 'Modal.Form.Label.Email' | translate }}</p>
			</div>
			<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pr">
				<p [ngStyle]="vm.ticket.patient.email.endsWith('eesti.ee') && {'color': 'red'}" class="c-text c-text--right">{{ vm.ticket.patient.email }}</p>
			</div>
		</div>
		<div class="c-divider c-divider--h c-divider--light"></div>
		<!-- User data: ticket info -->
		<div>
			<div class="o-grid u-osb-xs">
				<div class="o-grid__cell o-grid__cell--slim u-no-pl">
					<p class="c-text c-text--gray">{{ 'PreVisit.User_Tickets.Created' | translate }}</p>
				</div>
				<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pr">
					<p class="c-text c-text--right">{{ vm.ticket.created | date: 'dd.MM.yyyy HH:mm'  }}</p>
				</div>
			</div>
		</div>
        <div>
            <div class="o-grid u-osb-xs">
                <div class="o-grid__cell o-grid__cell--slim u-no-pl">
                    <p class="c-text c-text--gray">{{ 'PreVisit.User_Tickets.Doctor_Info' | translate }}</p>
                </div>
                <div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pr">
                    <p class="c-text c-text--right">
                        {{ vm.ticket.performer.user.firstname }} {{ vm.ticket.performer.user.lastname }}
                        <span *ngIf="vm.ticket.gpPatientListing"> ({{vm.ticket.gpPatientListing}})</span>
                    </p>
                </div>
            </div>
        </div>
        <div *ngIf="vm.ticket.requester && vm.ticket.requester.lastname">
            <div class="o-grid u-osb-xs">
                <div class="o-grid__cell o-grid__cell--slim u-no-pl">
                    <p class="c-text c-text--gray">{{ 'PreVisit.User_Tickets.Requester_Info' | translate }}</p>
                </div>
                <div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pr">
                    <p class="c-text c-text--right">
                        {{ vm.ticket.requester.firstname }} {{ vm.ticket.requester.lastname }}
                        <span *ngIf="vm.ticket.requesterRelationshipToPatient"> ({{vm.ticket.requesterRelationshipToPatient}})</span>
                    </p>
                </div>
            </div>
        </div>
        <div *ngIf="vm.ticket.requestRecorder && vm.ticket.requestRecorder.lastname">
            <div class="o-grid u-osb-xs">
                <div class="o-grid__cell o-grid__cell--slim u-no-pl">
                    <p class="c-text c-text--gray">{{ 'PreVisit.User_Tickets.Recorder_Info' | translate }}</p>
                </div>
                <div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pr">
                    <p class="c-text c-text--right">{{ vm.ticket.requestRecorder.firstname }} {{ vm.ticket.requestRecorder.lastname }}</p>
                </div>
            </div>
        </div>
		<div>
            <div class="o-grid u-osb-xs">
                <div class="o-grid__cell o-grid__cell--slim u-no-pl">
                    <p class="c-text c-text--gray">{{ 'PreVisit.User_Tickets.Type' | translate }}</p>
                </div>
                <div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pr">
                    <p class="c-text c-text--right">{{ vm.enumTranslations[vm.ticket.type] }}</p>
                </div>
            </div>
        </div>
        <div>
            <div class="o-grid u-osb-xs">
                <div class="o-grid__cell o-grid__cell--slim u-no-pl">
                    <p class="c-text c-text--gray">{{ 'PreVisit.User_Tickets.Status' | translate }}</p>
                </div>
                <div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pr">
                    <p class="c-text c-text--right">{{ vm.enumTranslations[vm.ticket.status] }}</p>
                </div>
            </div>
        </div>
        <div class="c-divider c-divider--h c-divider--light"></div>
        <!-- User data: ticket data -->
        <ng-container *ngFor="let ticketData of vm.ticketDatas ; let $index=index">
	        <div *ngIf="vm.isTicketDataDisplayed(ticketData) && ticketData.cleanedContent">
	            <div class="o-grid u-osb-xs">
	                <div class="o-grid__cell o-grid__cell--w-50 u-no-pl">
	                    <p class="c-text c-text--gray">{{ ticketData.config.label ? ticketData.config.label : (vm.enumTranslations[ticketData.config.fieldName] ? vm.enumTranslations[ticketData.config.fieldName] : ticketData.config.fieldName) }}</p>
	                </div>
	                <div class="o-grid__cell o-grid__cell--w-50 u-no-pr">
	                    <p class="c-text c-text--right">{{ ticketData.cleanedContent }}</p>
	                </div>
	            </div>
	        </div>
        </ng-container>
        <ng-container *ngIf="vm.links">
            <div class="c-divider c-divider--h c-divider--light"></div>
            <p class="c-text c-text--bold u-osb-sm">{{ 'PreVisit.User_Tickets.Links_Expire' | translate }}</p>
	        <div *ngFor="let link of vm.links ; let $index=index">
	            <div class="o-grid u-osb-xs">
	                <div class="o-grid__cell o-grid__cell--slim u-no-pl">
	                    <p class="c-text c-text--gray">{{ 'Common.Link' | translate }}</p>
	                </div>
	                <div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pr">
	                    <p class="c-text c-text--right"><a href="{{link}}" target="_blank">{{ 'Common.Download' | translate }}</a></p>
	                </div>
	            </div>
	        </div>
        </ng-container>
	</div>
	<loader-overlay *ngIf="vm.loading"></loader-overlay>
</div>
